<template>
  <!--div class="" >
    <div class="bg-secret">
      <div class="overlay"></div>
    </div>

    <div class="pincode">
      <div id="pin">
        <img src="../../src/assets/img/logo.png" class="img-logo-pin">
        <h4 class="text-pincode">Special Broadcast</h4>
        <p>กรุณากรอก PINCODE</p>
        <payPassword :length="4" v-model="pin" :class="{miss:css}"/>
        <p class="alert-pin">{{alert}}</p>
        <div class="numbers">
          <div class="number" @click="add(1)">1</div>
          <div class="number" @click="add(2)">2</div>
          <div class="number" @click="add(3)">3</div>
          <div class="number" @click="add(4)">4</div>
          <div class="number" @click="add(5)">5</div>
          <div class="number" @click="add(6)">6</div>
          <div class="number" @click="add(7)">7</div>
          <div class="number" @click="add(8)">8</div>
          <div class="number" @click="add(9)">9</div>
          <div class="number btn-space"></div>
          <div class="number" @click="add(0)">0</div>
          <div class="number" @click="del()"><i class="fa fa-arrow-left"></i></div>
        </div>
      </div>
    </div>
  </div-->

  <div class="" >
    <div class="bg-secret">
      <div class="overlay"></div>
    </div>

    <div class="pincode">
      <div id="pin">
        <!--img src="../../src/assets/img/logo.png" class="img-logo-pin"-->
        <div class="bg-header-pin">
          <h4 class="text-pincode">SPECIAL CHANNEL</h4>
        </div>

        <div class="bg-body-pin">
          <p>Please enter your PINCODE</p>
          <payPassword :length="4" v-model="pin" :class="{miss:css}"/>
          <p class="alert-pin">{{alert}}</p>
          <div class="playground">
            <div class="keypad">
              <div class="keypad-number" @click="add(1)">1</div>
              <div class="keypad-number" @click="add(2)">2</div>
              <div class="keypad-number" @click="add(3)">3</div>
              <div class="keypad-number" @click="add(4)">4</div>
              <div class="keypad-number" @click="add(5)">5</div>
              <div class="keypad-number" @click="add(6)">6</div>
              <div class="keypad-number" @click="add(7)">7</div>
              <div class="keypad-number" @click="add(8)">8</div>
              <div class="keypad-number" @click="add(9)">9</div>
              <div class="keypad-number"></div>
              <div class="keypad-number" @click="add(0)">0</div>
              <div class="keypad-number" @click="del()"><i class="fa fa-arrow-left"></i></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import payPassword from 'vue-pay-password';
import 'vue-pay-password/dist/vue-pay-password.css';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbCardHeader,
  mdbCardText,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbView,
  mdbMask,
  mdbCardImage,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  mdbIcon
} from 'mdbvue';
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
export default {
  name: 'PlayerSecretPage',
  components: {
    payPassword,
    mdbRow,
    mdbCol,
    Btn,
    mdbIcon,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbMask,
    Fa,
    mdbCardHeader,
    videojs,
    Slick,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      Publisher: null,
      status: '',
      css: false,
      alert: '',
      posterSecret: true,
      videoSecret: false,
      pin: '',
      views: null,
      Link: null,
      modalShare: false,
      active: 0,
      elHeight: 0,
      MessageDetail: '',
      Title: '',
      Desc: '',
      message: null,
      stream_url: '',
      player: null,
      msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      secret: [],
      Pincode: false
    };
  },
  mounted() {
    this.SecretList();
    this.addPincode();
    this.ToggleLogin();
    this.Session();
  },
  updated() {
    this.addPincode();
  },
  methods: {
    SecretList() {
      let APIgetSecretList = Host + '/api/v1/channel/secret';
      axios.get(APIgetSecretList).then(response => {
        localStorage.idSecret = response.data.result[0].id;
      });
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    addPincode() {
      if (this.pin.length == 4) {
        let APIgetCheckSecret = Host + '/api/v1/channel/secret/check';
        axios.post(APIgetCheckSecret , {
          pincode: this.pin
        }).then(response => {
          if (response.data.code == 200) {
            localStorage.pincode = this.pin;
            this.$router.replace({
              name: 'PlayerSecretPage'
            });
          } else {
            this.css = true;
            this.pin = '';
            this.alert = 'PINCODE is wrong !';
            var self = this;
            setTimeout(function () {
              self.alert = '';
              self.css = false;
            },2000);
          }
        });
      } else if (this.pin == '' && localStorage.pincode) {
        this.pin = localStorage.pincode;
      }
    },
    add(value) {
      if (this.pin.length < 4) {
        this.pin = this.pin + value;
        if (this.pin.length == 4) {
          this.addPincode();
        }
      }
    },
    del() {
      if (this.pin.length > 0) {
        this.pin = this.pin.substring(0, this.pin.length - 1);
      }
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    scrollToEnd() {
      var container = this.$el.querySelector(".body-chat");
      container.scrollTop = container.scrollHeight;
    },
    beforeEnter(el) {
      this.elHeight = el.scrollHeight;
    },
    enter(el) {
      el.style.height = this.elHeight + 'px';
    },
    beforeLeave(el) {
      el.style.height = 0;
    }
  }
};
</script>

<style lang="css">
.area-object {
  position: relative;
  overflow: hidden;
}

.area-player {
  width: 100%;
  height: auto;
}

.area-player img {
  max-width: 100%;
}

.area-chat-left {
  width: 100%;
  height: auto;
}

@media only screen and (min-width: 1080px) {
  /*.area-chat {
    display: none;
  }*/

  .area-player {
    width: 63%;
    float: left;
  }

}

.area-chat-left {
  width: 37%;
  height: auto;
  float: left;
  padding-left: 10px;
}

.chat-lable {
  padding: 12px;
}

.chat-lable h5 {
  margin-bottom: 0;
}

.form-chat {
  position: relative;
  padding-right: 90px;
}


.mesgs {
  padding: 0;
}

.msg_history {
  height: 350px;
  overflow-y: auto;
  background-color: #eeeeee;
  padding: 5px;
}

.incoming_msg_img {
  display: inline-block;
  width: 35px;
  margin-bottom: 15px;
}

.received_msg {
  display: inline-block;
  padding: 0;
  vertical-align: top;
  margin-right: 35px;
  width: 70%;
}

.received_withd_msg p {
  background: transparent none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 0;
  width: 100%;
}

.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}

.img-chat {
  max-width: 30px;
}

</style>
